import { DEFAULT_LOCALE, LOCALES, type Locale } from '@fdt/shared';
import it from '@fdt/shared/i18n/it.json';
import tr from '@fdt/shared/i18n/tr.json';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'fdt.locale';

function initialLocale(): Locale {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && (LOCALES as readonly string[]).includes(stored)) {
    return stored as Locale;
  }
  const browser = navigator.language.slice(0, 2);
  return (LOCALES as readonly string[]).includes(browser) ? (browser as Locale) : DEFAULT_LOCALE;
}

void i18next.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    tr: { translation: tr },
  },
  lng: initialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(locale: Locale): void {
  localStorage.setItem(STORAGE_KEY, locale);
  void i18next.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export function currentLocale(): Locale {
  return (i18next.language as Locale) ?? DEFAULT_LOCALE;
}

export default i18next;
